import React, { Component } from "react";
import { Link } from "gatsby";
import { ThemeToggler } from "gatsby-plugin-dark-mode";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

class TabletNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      dropdownOpen: false
    };
  }

  dropToggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  };

  render() {
    return (
      <header
        style={{
          background: "var(--navbg)",
          transition: "color 0.2s ease-out, background 0.2s ease-out"
        }}
      >
        <div className="container">
          <div className="row m-0">
            <div className="col-4 tab-logo">
              <Link to="/">
                <img
                  src={require("../../../assets/logo.png")}
                  alt="Logo Image"
                />
              </Link>
              <h2 className="companyName" style={{ color: "var(--h2Color)" }}>
                Tau. Support
              </h2>
            </div>

            <div className="col-6 p-0">
              <div
                className="form-group has-search my-2 mr-1 search-field "
                style={{
                  background: "var(--searchBg)",
                  borderRadius: "var(--searchBorderRadius)",
                  transition: "color 0.2s ease-out, background 0.2s ease-out"
                }}
              >
                <FontAwesomeIcon
                  icon={faSearch}
                  className="form-control-feedback ml-1 pt-2"
                />
                <input
                  type="text"
                  className="form-control border-0"
                  placeholder="Search"
                  style={{ background: "var(--searchBg)" }}
                />
              </div>
            </div>

            <div className="col-1 mob-dark-mode tab-dark-mode">
              <ThemeToggler>
                {({ theme, toggleTheme }) => (
                  <label className="tog ">
                    <input
                      type="checkbox"
                      onChange={e =>
                        toggleTheme(e.target.checked ? "light" : "dark")
                      }
                      checked={theme === "light"}
                    />
                    {theme === "dark" ? (
                      <img
                        className="img-fluid"
                        src={require("../../../assets/icons/dark-mode.svg")}
                        alt="dark-mode"
                      />
                    ) : (
                        <img
                          className="img-fluid"
                          src={require("../../../assets/icons/light-mode.svg")}
                          alt="light-mode"
                        />
                      )}
                  </label>
                )}
              </ThemeToggler>
            </div>

            <UncontrolledDropdown
              className="d-inline-block lang-drop"
              isOpen={this.state.dropdownOpen}
              toggle={this.dropToggle}
            >
              <DropdownToggle className="lang-flag-drop">
                <img
                  src={require("../../../assets/flags/us-flag.svg")}
                  className="img-fluid"
                />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>
                  <img
                    src={require("../../../assets/flags/us-flag.svg")}
                    className="img-fluid"
                  />
                </DropdownItem>
                <DropdownItem>
                  <img
                    src={require("../../../assets/flags/china-flag.svg")}
                    className="img-fluid"
                  />
                </DropdownItem>
                <DropdownItem>
                  <img
                    src={require("../../../assets/flags/es-flag.svg")}
                    className="img-fluid"
                  />
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>
      </header>
    );
  }
}

export default TabletNavbar;
